<script lang="ts" context="module">
	import { env } from "$lib/env.client";
	import { onMount } from "svelte";
</script>

<script lang="ts">
	onMount(() => {
		(function (c, l, a, r, i, t, y) {
			c[a] =
				c[a] ||
				function () {
					(c[a].q = c[a].q || []).push(arguments);
				};
			t = l.createElement(r);
			t.async = 1;
			t.src = "https://www.clarity.ms/tag/" + i;
			y = l.getElementsByTagName(r)[0];
			y.parentNode.insertBefore(t, y);
		})(window, document, "clarity", "script", env.PUBLIC_MICROSOFT_CLARITY_TRACKING_CODE);
	});
</script>
